import React from 'react';
import { Link } from 'react-router-dom';
import { hubs } from '../../data/site';
interface SiblingHubsProps {
  /** Titles to leave out — normally the hub you are already on. */
  exclude: string[];
}
const routeFor: Record<string, string> = {
  'Family events': '/events',
  'Things to do': '/things-to-do',
  'Parks & playgrounds': '/parks',
  'Classes & sports': '/classes',
  'Parent resources': '/for-parents'
};
export function SiblingHubs({
  exclude
}: SiblingHubsProps) {
  const shown = hubs.filter(h => !exclude.includes(h.title)).slice(0, 3);
  return <section aria-labelledby="siblings-h" className="bg-opal/30" data-id="element-138" data-mp="2nyf8v49jzpzr">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10" data-id="element-139" data-mp="31xev659lfssr">
        <h2 id="siblings-h" className="label text-ink/60" data-id="element-140" data-mp="2xu0fxgthbggd">
          Keep looking
        </h2>
        <ul className="mt-10 grid gap-x-14 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-141" data-mp="h539xvxqjxjf">
          {shown.map(hub => <li key={hub.path} className="group relative" data-id="element-142" data-mp="d2zoqfl9leky">
              <h3 className="font-display text-[26px] font-300 text-ink" data-id="element-143" data-mp="1hhkhpbdnhpup">
                <Link to={routeFor[hub.title] ?? '/things-to-do'} className="decoration-olive decoration-1 underline-offset-[7px] after:absolute after:inset-0 after:content-[''] group-hover:underline" data-id="element-144" data-mp="1hjoktr3q6ktx">
                  {hub.title}
                </Link>
              </h3>
              <p className="mt-3 text-[14px] leading-[1.75] text-ink/70" data-id="element-145" data-mp="yrcjn7ot5pld">
                {hub.blurb}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}